import dayjs from "dayjs";
import { INITIAL_SEARCH_FORM_VALUES, SearchFormInputs } from "../constants";
import { ReactNode } from "react";
import { explode } from "src/utility";

const formatDate = (date: string): string | undefined => {
  if (!date) return undefined;
  const usedDate = dayjs(date);
  return usedDate.locale("en").format("YYYY-MM-DD");
};

const createSegment = (
  origin: { label: ReactNode; value: string } | undefined,
  destination: { label: ReactNode; value: string } | undefined,
  date: string,
  cabinClass: number,
) => {
  return {
    origin: origin?.value ?? "",
    destination: destination?.value ?? "",
    preferredDepartureTime: formatDate(date),
    flightCabinClass: cabinClass,
  };
};

const mapFlightSearchToSubmitObject = (searchFormInputObject: SearchFormInputs) => {
  if (!searchFormInputObject) return null;
  const { passengers, journeyType, origin, destination, preferredDepartureTime, preferredReturnTime, flightCabinClass, directFlight } = explode(
    searchFormInputObject,
    INITIAL_SEARCH_FORM_VALUES,
  );
  const segments = [createSegment(origin, destination, preferredDepartureTime, flightCabinClass)];

  if (journeyType === 2) {
    segments.push(createSegment(destination, origin, preferredReturnTime, flightCabinClass));
  }

  return {
    directFlight,
    passengers,
    journeyType,
    segments,
  };
};

export { mapFlightSearchToSubmitObject };
